import { Link } from "react-router-dom";

// Shared site footer. Rendered inside Chrome so it shows on every page that
// gets the TopBar (legal/landing/dashboard). Overlay + fake-checkout are
// chrome-less and intentionally skip this.

export default function Footer(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="tw-footer">
      <div className="tw-footer-row">
        <div className="tw-foot-brand">© {year} SubsWall · 4.9% take, 95.1% to creators</div>
        <nav>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/refunds">Refunds</Link>
          <Link to="/acceptable-use">Acceptable Use</Link>
          <Link to="/dmca">DMCA</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>
    </footer>
  );
}
